<div #width style="height: 0px; width: 100%;"></div>
<div *ngIf="ui?.echart && !ui?.noData" style="height: 100%;" echarts [options]="ui?.echart" [autoResize]="true" (chartClick)="onChartClicked($event)"></div>
<div *ngIf="!ui?.echart || !_data?.length || ui?.noData" class="d-flex justify-content-center align-items-center" style="height: 100%; width: 100%;">
    <span>{{ui.noDataMsg}}</span>
</div>